import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {LonerSpinResultPresentation} from "./base/LonerSpinResultPresentation";
import {Loner} from "../Loner";
import {LonerStatics} from "../LonerStatics";
import {SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {SimpleReelModelEventData} from "../reels/LonerReelModel";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

/**
 * Created by Jerker Nord on 2022-12-02.
 */

export class LonerNormalResultPresentation extends LonerSpinResultPresentation {

    protected doStop():void {
        this._controller.setSkipCallback(() => this.skip());
        this._stoppedReels = [false, false, false, false, false];
        const isFastSpin:boolean = Loner.apiPlugin.settings.get(APISetting.FAST_SPIN, false);

        if (this._tl){
            this._tl.kill();
        }
        this._tl = gsap.timeline();
        this._tl.add(()=>{
            this._controller.setSkipCallback(() => this.skip());
        });

        for(let i:number = 0; i < Loner.model.gameData.reels.length; i++) {
            let stopDelay:number = isFastSpin ? LonerStatics.reelStopDelayFastSpin[i] : LonerStatics.reelStopDelayNormal[i];
            const reelData:string[] = Loner.model.gameData.reels[i];
            const reelStopAnimation:gsap.core.Timeline = gsap.timeline();
            const featureBuyName:string | undefined = Loner.apiPlugin.betFeatureController.getActiveBetFeature()?.name;

            if(featureBuyName && featureBuyName == "PIN_THE_WIN" || featureBuyName == "TICK_TICK_BOOM" || featureBuyName == "SHOOT_SHOOT_DUCK") {
                stopDelay = LonerStatics.reelStopDelayFastSpin[i];
            }

            const activeFeature:BetFeature | undefined = Loner.apiPlugin.betFeatureController.getActiveBetFeature();
            if(Loner.model.scatterAnticipationReels[i]) {
                if(activeFeature && (activeFeature.name == "LUCKY DRAW" || activeFeature.name == "LUCKY_DRAW_2")) {
                    stopDelay += LonerStatics.SCATTER_ANTICIPATION_DELAY_LUCKY_DRAW;
                } else {
                    stopDelay += isFastSpin ? LonerStatics.SCATTER_ANTICIPATION_DELAY_FAST : LonerStatics.SCATTER_ANTICIPATION_DELAY_NORMAL;
                }
            }

            if(Loner.model.bigWildOnReels[i] == true) {
                stopDelay = 0.001;
            }

            reelStopAnimation.add(() => Loner.allReelView.mainReelModels[i].doStop(reelData), "+=" + stopDelay);

            Loner.allReelView.mainReelModels[i].events?.once(SimpleReelModelState.STOPPED, (data:SimpleReelModelEventData) => this.onReelStop(data, this._controller));
            Loner.allReelView.mainReelModels[i].events?.once(SimpleReelModelState.BOUNCE, (data:SimpleReelModelEventData) => this.onReelBounce(data));

            this._tl.add(reelStopAnimation);
        }

        const padding:number = Loner.gameFlowController.calculatePaddingDuration(this._tl.totalDuration());
        if(padding > 0) {
            this._tl.delay((padding - 0.5));
        }
    }
}